import React, { Suspense, lazy } from "react";
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
import Main from "../../components/Main";
import Content from "../../components/Content/Content";
import ScrollToTop from "../../components/ScrollToTop/ScrollToTop";

const ParticleBackground = lazy(() =>
  import("../../components/ParticlesBg/ParticleBackground")
);


const Home = () => {
  return (
    <div>
      <Header />

      <Suspense fallback={null}>
        <ParticleBackground />
      </Suspense>

      <section className="home-content">
        <Content />
      </section>

      <Main />
      <ScrollToTop />
      <Footer />
    </div>
  );
};

export default Home;
